// Copyright (c) 2017 Deere & Company

import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import t from 'tcomb';

const LaborRateChanges = t.list(LaborRate, 'LaborRateChanges');

export const getDefaultState = () => new LaborRateChanges([]);

export default LaborRateChanges;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/labor-rate-changes.js